import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {IExgTab} from 'exc-tab-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {CalculationSpreadsheetComponent} from '../calculation-spreadsheet/calculation-spreadsheet.component';
import {ModalCalculationVersionComponent} from '../modals/modal-calculation-version.component';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';


@Component({
  selector: 'app-calculation-version',
  templateUrl: './calculation-version.component.html',
  styles: []
})
export class CalculationVersionComponent extends ExcTranslation implements OnInit, IExgTab {
  @ViewChild(CalculationSpreadsheetComponent) VCSpreadsheet!: CalculationSpreadsheetComponent;

  tabinstance: any;

  Data: any;
  isTemplateMode = false;
  showSignatureButton = false;
  signatureSheetName = '';

  Events = new ExgApplicationEventEmitter();

  isNew = false;
  loaded = false;
  closeTabinstance = false;

  ID: string | undefined = undefined;
  cvData: {
    cvID: string | undefined,
    cv_ctID: string | undefined,
    cv_fkID: string | undefined,
    cvUPT: string | undefined,
    cvName: string | undefined,
    cvDescription: string | undefined,
    cvCalculationVersionStatus_enmIdent: number | undefined,
    cvData: any,
    cvExtractedData: string | undefined,
    ctAutoFillColumns: string | undefined
  } = {
    cvID: undefined,
    cv_ctID: undefined,
    cv_fkID: undefined,
    cvUPT: undefined,
    cvName: '',
    cvDescription: '',
    cvCalculationVersionStatus_enmIdent: undefined,
    cvData: undefined,
    cvExtractedData: undefined,
    ctAutoFillColumns: ''
  };
  info: any =
    {
      aueSchadenNr: 'SAG1292391',
      auOKZ: 'Test1234',
      aueSchadenart: 'LW',
      aueSchadendatum: '21.06.2024',
      aueVN_KontHandy: '01731234567',
      aueSchadenort: 'Siemensstr. 10, 63263 Neu-Isenburg',
      aueVN_Name: 'Mustermann',
      aueVN_Vorname: 'Martina',
      aueSelbstbehalt: 200
    };

  constructor(private excRest: ExcRestService,
              public excSecurity: ExcSecurityService,
              private modal: ExgModalService) {
    super();
  }

  isReadOnly(): boolean {
    return [10, 20].includes(this.cvData?.cvCalculationVersionStatus_enmIdent as number);
  }

  ngOnInit(): void {
    this.initialize();
    this.tabinstance.BeforeClose = () => {
      return this.checkBeforeClose();
    };
    // this.tabinstance.Config.Close = () => {
    //   this.Data.Events?.Message?.NewForTask?.Closed?.emit();
    // };
  }

  initialize(): void {
    if (this.Data.isNewFromPreset) {
      this.isNew = true;
      this.isTemplateMode = true;
      const templateId = this.Data.templateCvID || this.Data.cvID;
      this.excRest.get(this.excRest.computeUrl('CalculationVersionR', {cvID: templateId}))
        .subscribe((response: any) => {
          if (response?.success) {
            this.cvData.cv_fkID = this.Data.cv_fkID;
            this.cvData.cv_ctID = this.Data.cv_ctID;
            this.cvData.cvCalculationVersionStatus_enmIdent = 2;
            this.cvData.cvData = response.data.CalculationVersion.cvData;
            this.checkSignatureFields();
            this.loaded = true;
          }
        });
    } else if (!this.Data.cvID && !this.Data.templateCvID) {
      this.isNew = true;
      this.excRest.get(this.excRest.computeUrl('CalculationTemplateR', {ctID: this.Data.cv_ctID, fkID: this.Data.cv_fkID}))
        .subscribe((response: any) => {
          if (response?.success) {
            this.cvData.cv_fkID = this.Data.cv_fkID;
            this.cvData.cv_ctID = this.Data.cv_ctID;
            this.cvData.cvCalculationVersionStatus_enmIdent = 2;
            this.cvData.cvData = response.data.CalculationTemplate.ctData;
            this.info = response.data.ForeignData;
            this.loaded = true;
          }
        });
    } else if (this.Data.templateCvID) {
      this.isNew = true;
      this.isTemplateMode = false;
      this.excRest.get(this.excRest.computeUrl('CalculationVersionR', {cvID: this.Data.templateCvID}))
        .subscribe((response: any) => {
          if (response?.success) {
            this.cvData.cv_fkID = this.Data.cv_fkID;
            this.cvData.cv_ctID = this.Data.cv_ctID;
            this.cvData.cvCalculationVersionStatus_enmIdent = 2;
            this.cvData.cvData = response.data.CalculationVersion.cvData;
            this.loaded = true;
          }
        });
    } else {
      this.isNew = false;
      this.excRest.get(this.excRest.computeUrl('CalculationVersionR', {cvID: this.Data.cvID}))
        .subscribe((response: any) => {
          if (response?.success) {
            this.cvData = response.data.CalculationVersion;
            this.cvData.ctAutoFillColumns = response.data.CalculationVersion.ctAutoFillColumns;
            this.checkSignatureFields();
            this.loaded = true;
            this.info = response.data.ForeignData;
            if (this.cvData.ctAutoFillColumns && this.cvData.ctAutoFillColumns.length > 0) {
              this.updateAutoFillColumns(JSON.parse(this.cvData.ctAutoFillColumns));
            }
          }
        });
    }
  }


  async calculationSave(cancelSave = false, skipMessage = false, skipReload = false, $event?: any): Promise<void> {
    if (this.VCSpreadsheet) {
      await this.VCSpreadsheet.normalizeSpreadsheetColors();
      await this.VCSpreadsheet.normalizeSpreadsheetFontSizes();
    }

    if ($event) {
      await this.save(cancelSave, skipMessage, skipReload, $event.jsonWorkbook, $event.extractedData);
    } else {
      if (this.VCSpreadsheet?.spreadsheetObj) {
        this.VCSpreadsheet.spreadsheetObj.endEdit();

        const extractedData = await this.VCSpreadsheet.extractData();

        const json: any = await this.VCSpreadsheet.spreadsheetObj.saveAsJson();
        await this.save(cancelSave, skipMessage, skipReload, json.jsonObject, extractedData);
      }
    }
  }

  save(cancelSave = false, skipMessage = false, skipReload = false, jsonWorkbook: any, extractedData: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      if (!jsonWorkbook || !extractedData) {
        resolve();
        return;
      }

      if (cancelSave) {
        if (this.VCSpreadsheet) {
          this.VCSpreadsheet.isDirty = false;
        }
        this.isNew = false;
        this.modal.showToast(this.getResource('Canceled'), 'md-toast', 'far fa-window-close');
        this.closeTab();
        resolve();
        return;
      }

      this.cvData.cvData = JSON.stringify(jsonWorkbook);
      this.cvData.cvExtractedData = extractedData;

      if (!this.isNew) {
        if (!this.VCSpreadsheet.isDirty) {
          resolve();
          return;
        }

        if (!skipMessage) {
          this.modal.showToast('Kalkulation wird gespeichert', 'md-toast', 'fa-solid fa-download');
        }

        this.excRest.put(this.excRest.computeUrl('CalculationVersionU', {cvID: this.cvData.cvID}), this.cvData).subscribe({
          next: (response: any) => {
            if (response?.success && response.data?.CalculationVersion) {
              this.cvData = response.data.CalculationVersion;
              this.cvData.cv_fkID = response.data.CalculationVersion.cv_FKID || response.data.CalculationVersion.cv_fkID;
              this.checkSignatureFields();
              this.Data.Events?.Calculation?.Version?.Closed?.emit();
              this.loaded = true;
              if (this.VCSpreadsheet) {
                this.VCSpreadsheet.isDirty = false;
              }
              if (!skipMessage) {
                this.modal.showToast('Kalkulation gespeichert', 'md-toast bg-green', 'far fa-check');
              }
            } else {
              this.loaded = true;
            }
            this.closeTab();
            resolve(); // ← PUT abgeschlossen
          }, error: (err) => reject(err)
        });
      } else {
        const modalData = Object.assign({}, this.cvData, { isNewVersion: true });

        this.modal.show('ModalCalculationVersionComponent', modalData)
          .subscribe({
            next: (retValue: any) => {
              if (!retValue) {
                resolve(); // ← Modal abgebrochen
                return;
              }

              if (!skipMessage) {
                this.modal.showToast('Kalkulation wird gespeichert', 'md-toast', 'fa-solid fa-download');
              }
              if (!skipReload) {
                this.loaded = false;
              }

              const savePayload = Object.assign({}, retValue, {
                cvData: this.cvData.cvData,
                cvExtractedData: this.cvData.cvExtractedData,
                cv_ctID: this.cvData.cv_ctID,
                cv_fkID: this.cvData.cv_fkID,
                cvCalculationVersionStatus_enmIdent: this.cvData.cvCalculationVersionStatus_enmIdent
              });

              this.excRest.post(
                this.excRest.computeUrl('CalculationVersionC', {
                  fkid: this.cvData.cv_fkID,
                  cv_ctID: this.cvData.cv_ctID
                }),
                savePayload
              ).subscribe({
                next: (response: any) => {
                  if (response?.success && response.data?.CalculationVersion) {
                    const responseData = response.data.CalculationVersion;
                    this.cvData = responseData;
                    this.cvData.cv_fkID = responseData.cv_fkID;
                    this.cvData.cvUPT = responseData.cvUPT;
                    this.isNew = false;
                    this.isTemplateMode = false;
                    this.loaded = true;
                    if (this.VCSpreadsheet) {
                      this.VCSpreadsheet.isDirty = false;
                    }
                    this.Data.cvID = this.cvData.cvID;
                    this.Data.cv_ctID = this.cvData.cv_ctID;
                    this.Data.cv_fkID = this.cvData.cv_fkID;
                    this.ID = this.cvData.cvID;

                    if (this.tabinstance?.Label) {
                      this.tabinstance.Label = this.cvData.cvName;
                      // console.log('tabinstance:', this.tabinstance);
                    }

                    if (this.tabinstance) {
                      this.tabinstance._id = CalculationVersionComponent.name + '-' + this.cvData.cvID;
                    }
                    this.checkSignatureFields();
                    this.Data.Events?.Calculation?.Version?.Closed?.emit();

                    if (!skipMessage) {
                      this.modal.showToast('Kalkulation gespeichert', 'md-toast bg-green', 'far fa-check');
                    }
                  } else {
                    this.loaded = true;
                  }
                  this.closeTab();
                  resolve(); // ← POST abgeschlossen
                },
                error: (err) => reject(err)
              });
            },
            error: (err) => reject(err)
          });
      }
    });
  }

  openModalCalculationVersion(): void {
    if (!this.isNew) {
      this.modal.show('ModalCalculationVersionComponent', this.cvData)
        .subscribe((retValue: any) => {
          if (retValue) {
            if (retValue.del) {
              this.excRest.delete(
                this.excRest.computeUrl(
                  'CalculationVersionD', {
                    cvID: this.cvData.cvID
                  }
                ), {
                  cvID: this.cvData.cvID,
                  cvUPT: this.cvData.cvUPT,
                }).subscribe((response: any) => {
                if (response?.success) {
                  this.modal
                    .showToast('Kalkulation gelöscht'
                      , 'md-toast bg-green'
                      , 'far fa-check');
                  this.tabinstance.config.Close();
                  this.tabinstance.Close();
                }
              });
            } else {
              if (!this.isNew) {
                this.excRest.put(
                  this.excRest.computeUrl(
                    'CalculationVersionU', {
                      cvID: this.cvData.cvID
                    }
                  ), retValue).subscribe((response: any) => {
                  if (response?.success) {
                    this.cvData = response.data.CalculationVersion;
                    this.checkSignatureFields();
                    this.loaded = true;
                  }
                });
              }
            }
          }
        });
    }
  }

  async exportSheets(modalValue: any): Promise<void> {
    if (modalValue) {
      await this.calculationSave();

      this.excRest.post(
        this.excRest.computeUrl(
          'CalculationVersionC_ExportSheet', {
            cvID: this.cvData.cvID
          }
        ), modalValue, {
          OnProgress: () => {
            this.modal
              .showToast(
                'Export in Auftrag und Vorgang'
                , 'md-toast app-opacity'
                , 'fa-solid fa-cloud-upload-alt');
          }
        }).subscribe((response: any) => {
        if (response?.success) {
          this.modal.showToast('Erfolgreich', 'md-toast bg-green', 'fa-solid fa-upload');
        }
      });
    }
  }

  async downloadSheets(modalValue: any): Promise<void> {
    if (modalValue) {
      await this.calculationSave();

      this.excRest.post(
        this.excRest.computeUrl(
          'CalculationVersionR_DownloadSheet', {
            cvID: this.cvData.cvID
          }
        ), modalValue, {
          export: true,
          OnProgress: () => {
            this.modal
              .showToast(
                'Download wird gestartet'
                , 'md-toast app-opacity'
                , 'fa-solid fa-download');
          }
        }
      ).subscribe((response: any) => {
        if (response?.success) {
          this.modal.showToast('Download gestartet', 'md-toast bg-green', 'fa-solid fa-download');
        }
      });
    }
  }

  download(): void {
    if (!this.isNew){
      this.excRest.get(this.excRest.computeUrl('CalculationVersionR', {cvID: this.Data.cvID, export: true}), {export: true})
        .subscribe((response: any) => {
          /*if (response?.success) {
            this.cvData = response.data.CalculationVersion;
            this.loaded = true;
          }*/
        });
    }
  }

  async doSignature(): Promise<void> {
    if (this.isNew || !this.VCSpreadsheet?.spreadsheetObj) {
      return;
    }

    await this.calculationSave();

    this.openSignatureModal();
  }

  openSignatureModal(): void {
    if (this.isNew || !this.VCSpreadsheet?.spreadsheetObj) {
      return;
    }

    this.modal.show('ModalCalculationSignatureComponent', {
      cvID: this.cvData.cvID,
      title: 'Schlusserklärung unterschreiben',
      labelVN: 'Versicherungsnehmer',
      labelEntgegen: 'Entgegengenommen'
    })
      .subscribe((result: any) => {
        if (result && result.signatureVN && result.signatureEntgegen) {
          this.excRest.post(
              this.excRest.computeUrl('CalculationVersionC_SignedPDF', {cvID: this.cvData.cvID}
            ), {
              sheetName: this.signatureSheetName,
              signatureVN: result.signatureVN,
              signatureEntgegen: result.signatureEntgegen,
              saveToDocument: true,
              sourceID: this.Data.sourceID || null
            }, {export: true}
          ).subscribe((res: any) => {
            if (res?.success) {
              this.modal.showToast('PDF erstellt', 'md-toast bg-green', 'fal fa-check');
            } else {
              this.modal.showToast('PDF Export fehlgeschlagen', 'md-toast bg-red', 'fal fa-times');
            }
          });
        }
      });
  }

  checkSignatureFields(): void {
    this.showSignatureButton = false;
    this.signatureSheetName = '';

    if (!this.cvData?.cvData) {
      return;
    }

    try {
      const data = typeof this.cvData.cvData === 'string'
        ? JSON.parse(this.cvData.cvData)
        : this.cvData.cvData;

      const sheets = data?.Workbook?.sheets || [];

      for (const sheet of sheets) {
        const rows = sheet?.rows || [];
        for (const row of rows) {
          const cells = row?.cells || [];
          for (const cell of cells) {
            const value = String(cell?.value || '');
            if (value.includes('{{SIGN_VN}}') || value.includes('{{SIGN_ENTGEGEN}}')) {
              this.showSignatureButton = true;
              this.signatureSheetName = sheet.name;
              return;
            }
          }
        }
      }
    } catch (e) {
      console.error('checkSignatureFields error' + e);
    }
  }

  async updateAutoFillColumns(autoFillColumns: any[]): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 1000));

    for (const autoFillColumn of autoFillColumns) {
      const columnPlaceholder = String(autoFillColumn.value ?? '');

      const filled = columnPlaceholder.replace(/{{\s*([^}]+?)\s*}}/g, (match, key) => {
        const replacekey = String(key).trim();
        const replaceValue = (this.info as any)?.[replacekey];

        return replaceValue != null ? String(replaceValue) : match.includes('SIGN') ? match : '';
      });

      if (!filled.includes('SIGN')) {
        this.VCSpreadsheet.setCellValueByIndex(
          autoFillColumn.sheetIndex,
          autoFillColumn.rowIndex,
          autoFillColumn.colIndex,
          filled
        );
      }
    }

    await this.calculationSave(false, true);
  }

  checkBeforeClose(): boolean {
    if (!this.VCSpreadsheet?.isDirty && !this.isNew) {
      this.Data.Events?.Calculation?.Version?.Closed?.emit();
      return true;
    }
    this.modal
      .showSimple(
        this.getGlobal('Attention') + '!',
        this.getResource('UnsavedChanges'),
        true,
        true,
        this.getGlobal('Save'),
        this.getGlobal('Reject')
      )
      .subscribe(async (ret: boolean) => {
        this.closeTabinstance = true;
        await this.calculationSave(!ret, false, true);
      });
    return false;
  }

  closeTab(): void {
    if (this.closeTabinstance) {
      this.tabinstance.Close();
    }
  }
}
